const getRecommendedSpfFromWeatherIcon = (weatherIcon: string): number | null => {
  switch (weatherIcon) {
    case 'CLEAR':
    case 'CLEAR_FREEZING_RAIN':
    case 'CLEAR_HAIL':
    case 'CLEAR_NO_RAIN':
    case 'CLEAR_RAIN':
    case 'CLEAR_SNOW':
    case 'MOSTLY_CLEAR':
    case 'MOSTLY_CLEAR_FREEZING_RAIN':
    case 'MOSTLY_CLEAR_HAIL':
    case 'MOSTLY_CLEAR_NO_RAIN':
    case 'MOSTLY_CLEAR_RAIN':
    case 'MOSTLY_CLEAR_SNOW':
      return 50;

    case 'BLIZZARD':
    case 'BRIEF_FREEZING_RAIN_SHOWERS':
    case 'BRIEF_HEAVY_SNOW_SHOWERS':
    case 'BRIEF_ICE_PELLETS_SHOWERS':
    case 'BRIEF_SHOWERS':
    case 'BRIEF_SHOWERS_POSSIBLE':
    case 'BRIEF_SNOW_FLURRIES':
    case 'BRIEF_SNOW_SHOWERS':
    case 'CLOUDY':
    case 'DRIZZLE':
    case 'FOG':
    case 'FREEZING_RAIN':
    case 'FREEZING_RAIN_SHOWERS':
    case 'HEAVY_RAIN':
    case 'HEAVY_SHOWERS':
    case 'HEAVY_SHOWERS_POSSIBLE':
    case 'HEAVY_SNOW':
    case 'HEAVY_SNOW_SHOWERS':
    case 'HEAVY_THUNDER_SHOWERS':
    case 'HEAVY_THUNDER_STORMS':
    case 'ICE_PELLETS':
    case 'ICE_PELLETS_SHOWERS':
    case 'LIGHT_RAIN':
    case 'LIGHT_RAIN_AND_FOG':
    case 'LIGHT_SHOWERS':
    case 'LIGHT_SHOWERS_POSSIBLE':
    case 'LIGHT_SNOW':
    case 'LIGHT_SNOW_SHOWERS':
    case 'MIST':
    case 'MOSTLY_CLOUDY':
    case 'MOSTLY_CLOUDY_FREEZING_RAIN':
    case 'MOSTLY_CLOUDY_HAIL':
    case 'MOSTLY_CLOUDY_NO_RAIN':
    case 'MOSTLY_CLOUDY_RAIN':
    case 'MOSTLY_CLOUDY_SNOW':
    case 'OVERCAST':
    case 'OVERCAST_HAIL':
    case 'OVERCAST_HAIL_FREEZING_RAIN':
    case 'OVERCAST_NO_RAIN':
    case 'OVERCAST_RAIN':
    case 'OVERCAST_SNOW':
    case 'PARTLY_CLOUDY_FREEZING_RAIN':
    case 'PARTLY_CLOUDY_HAIL':
    case 'PARTLY_CLOUDY_NO_RAIN':
    case 'PARTLY_CLOUDY_RAIN':
    case 'PARTLY_CLOUDY_SNOW':
    case 'RAIN':
    case 'RAIN_AND_FOG':
    case 'SEVERE_BLIZZARD':
    case 'SEVERE_SNOW_SQUALLS':
    case 'SEVERE_THUNDER_STORMS':
    case 'SHOWERS':
    case 'SNOW':
    case 'SNOW_SHOWERS':
    case 'SNOW_SQUALLS':
    case 'THUNDER_SHOWERS':
    case 'THUNDER_STORMS':
    case 'TORRENTIAL_RAIN':
      return 30;
    default:
      return null;
  }
};

export default getRecommendedSpfFromWeatherIcon;
